import { Module, VuexModule, Mutation } from 'vuex-module-decorators';

export interface Snack {
  id: number;
  text: string;
}

// A two-word confirmation and a two-sentence one do not deserve the same time
// on screen, and the fixed 2s was not long enough to read the longer ones (the
// email-change confirmation in admin `UserEdit` in particular). Roughly reading
// speed, floored at the old 2s so nothing became quicker, and capped so a long
// message cannot sit there indefinitely. A mutation takes one payload, so the
// duration is derived from the text rather than passed by the caller.
const MIN_DURATION = 2000;
const MAX_DURATION = 9000;
const MS_PER_CHAR = 60;

export function snackDuration(text: string): number {
  return Math.min(
    MAX_DURATION,
    Math.max(MIN_DURATION, text.length * MS_PER_CHAR),
  );
}

@Module({
  name: 'SnackModule',
  namespaced: true,
})
export default class SnackModule extends VuexModule {
  snacks: Snack[] = [];

  nextSnackId: number = 0;

  get snacksVisible() {
    return this.snacks.length > 0;
  }

  @Mutation
  showSnackbar(text: string) {
    const id = this.nextSnackId;
    this.nextSnackId += 1;
    this.snacks.push({ id, text });
    // Removed by id, not by position: durations now differ per snack, so two
    // overlapping messages do not necessarily expire in the order they arrived.
    window.setTimeout(() => {
      const index = this.snacks.findIndex(snack => snack.id === id);
      if (index > -1) {
        this.snacks.splice(index, 1);
      }
    }, snackDuration(text));
  }
}
